<template>
    <div class="container-with-elements">
        <p><label class="form-label">{{$t('utils.date')}}:</label> {{ elementDate | date }}</p>
        <hour-field
            ref="hourfield"
            :value="element.values.date"
            :field="bloodTestFields.date"
            :prefix-field-name="prefix"
            :label="$t('bloodTest.extractionHour')"
            field-name="date"
            time
            @input="addTimeToDate"
        />
        <div class="d-inline-flex flex-column mr-3 container-with-elements">
            <select-as-radio-field
                v-model="element.values.fviii_unit"
                :field="bloodTestFields.fviii_unit"
                :choices="bloodTestFields.fviii_unit.choices"
                :prefix-field-name="prefix"
                field-name="fviii-unit"
            />
            <input-field
                v-model="element.values.fviii_c"
                :field="bloodTestFields.fviii_c"
                :prefix-field-name="prefix"
                :unit="element.values.fviii_unit"
                field-name="fviii-c"
                type="number"
            />
            <input-field
                v-model="element.values.fviii_cr"
                :field="bloodTestFields.fviii_cr"
                :prefix-field-name="prefix"
                :unit="element.values.fviii_unit"
                field-name="fviii-cr"
                type="number"
            />
        </div>

        <div class="d-inline-flex flex-column mr-3 container-with-elements">
            <input-field
                :field="bloodTestFields.hemoglobin"
                v-model="element.values.hemoglobin"
                field-name="hemoglobin"
                type="number"
                :prefix-field-name="prefix"
                show-help-as-unit
            />
            <input-field
                :field="bloodTestFields.platelets"
                v-model="element.values.platelets"
                field-name="platelets"
                :prefix-field-name="prefix"
                type="number"
                show-help-as-unit
            />
        </div>
        <br>

        <p v-if="serverErrors" class="invalid-feedback d-inline-block">{{ serverErrors }}</p>

        <create-cancel-buttons
            :ok-title="saveButtonTitle"
            :ok-function="checkAndSave"
            :cancel-title="$t('utils.cancel')"
            :cancel-function="close"
        />
    </div>
</template>

<script>
    import {mapActions, mapState} from "vuex";
    import DetailSurgeryElementMixin from "@/components/surgery/detail/elements/DetailSurgeryElementMixin";
    import InputField from "@/components/fields/InputField";
    import HourField from "@/components/fields/HourField";
    import {required} from "vuelidate/lib/validators";
    import SelectAsRadioField from "@/components/fields/SelectAsRadioField";
    import CreateCancelButtons from "@/components/surgery/detail/elements/CreateCancelButtons";

    export default {
        name: "DetailSurgeryBloodTest",
        components: {CreateCancelButtons, SelectAsRadioField, HourField, InputField},
        mixins: [DetailSurgeryElementMixin],
        computed: {
            ...mapState(['bloodTestFields']),
        },
        created() {
            this.prefix = 'bloodtest-' + this.element.values.id;
            this.updateFunction = this.updateBloodTest;
            this.createFunction = this.createBloodTest;
        },
        methods: {
            ...mapActions([
                'updateBloodTest',
                'createBloodTest',
            ]),
            checkAndSave() {
                this.$refs.hourfield.createDate();
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    this.save();
                }
            },
        },
        validations: {
            element: {
                values: {
                    date: {
                        required,
                        validDate: function () {
                            return !this.$refs.hourfield.$v.$invalid;
                        },
                    },
                }
            }
        }

    };
</script>

<style scoped>

</style>